const ITEM_TEMPERATURE = {
	fridge: {
		name: 'FRIDGE',
		icon: '💦',
	},
	freezer: {
		name: 'FREEZER',
		icon: '❄️',
	},
	room: {
		name: 'ROOM',
		icon: '',
	},
	fruitVegetable: {
		name: 'FRUIT_VEGETABLE',
		icon: '🧅🥔',
	},
	bakery: {
		name: 'BAKERY',
		icon: '🍞',
	},
	fruitVegetableBox: {
		name: 'FRUIT_VEGETABLE_BOX',
		icon: '📦🍌🥬',
	},
};

export default ITEM_TEMPERATURE;